import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setLayout = 'SET_LAYOUT',
  setLang = 'SET_LANG',
  setUser = 'SET_USER',
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG',
  setPortal = 'SET_PORTAL',
  setCountryData = 'SET_COUNTRY_DATA'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
